import styled from 'styled-components';

export const PrivacyPolicyLogo = styled.img`
        max-width: 320px;
        width: 50%;
        margin-bottom: 40px;
`;
